import React, { useEffect, useState } from 'react';
function getTimeUntilMidnight() {
  const now = new Date();
  const midnight = new Date(now);
  midnight.setHours(23, 59, 59, 999);
  const diff = midnight.getTime() - now.getTime();
  if (diff <= 0) return {
    hours: 0,
    minutes: 0,
    seconds: 0
  };
  const hours = Math.floor(diff / (1000 * 60 * 60));
  const minutes = Math.floor(diff % (1000 * 60 * 60) / (1000 * 60));
  const seconds = Math.floor(diff % (1000 * 60) / 1000);
  return {
    hours,
    minutes,
    seconds
  };
}
function pad(n: number) {
  return n.toString().padStart(2, '0');
}
export function PromoBanner() {
  const [time, setTime] = useState(getTimeUntilMidnight);
  useEffect(() => {
    const interval = setInterval(() => {
      setTime(getTimeUntilMidnight());
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  return <div className="fixed top-0 left-0 right-0 z-[9999] flex flex-col items-center justify-center px-4 py-2 border-b border-black/5" style={{
    backgroundColor: '#F0EBE1',
    minHeight: 60
  }} data-id="element-241">
      <p className="text-charcoal font-semibold text-sm leading-tight text-center m-0" data-id="element-242">
        Hoy: Método 7D por solo $6.36
      </p>
      <p className="text-charcoal/50 text-xs leading-tight text-center m-0 mt-0.5 font-normal" data-id="element-243">
        Vuelve a $19.99 en{' '}
        <span className="font-medium text-charcoal/60 tabular-nums" data-id="element-244">
          {pad(time.hours)}:{pad(time.minutes)}:{pad(time.seconds)}
        </span>
      </p>
    </div>;
}